import { render, staticRenderFns } from "./UiPartSearchSelectBox.vue?vue&type=template&id=89f544e4&scoped=true"
import script from "./UiPartSearchSelectBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiPartSearchSelectBox.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f544e4",
  null
  
)

export default component.exports